import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { MASTER_DATA, USERS, JOBS, NOTIFICATIONS, HOME } from 'src/routes/routes';
import CurrentUserPermissionsContext from 'src/utils/context/CurrentUserPermissionsContext';
import CurrentUserContext from 'src/utils/context/CurrentUserContext';
import s from './Menu.styles';

const Menu = ({ match: { path }, expanded }) => {
  const { permissions } = useContext(CurrentUserPermissionsContext);
  const user = useContext(CurrentUserContext);

  const isAdmin = user.roles?.some(role => role.name === 'Admin' );
  const hasUsersAccess = permissions?.some(permission => permission.resourceName === 'User' && permission.name === 'read');
  const hasMasterDataAccess = permissions?.some(permission => (permission.resourceName === 'MasterData' || permission.resourceName === 'Survey') && permission.name === 'read');

  const isDashboardActive = path === HOME;
  const isUsersActive = path.indexOf(USERS) === 0;
  const isMasterDataActive = path.indexOf(MASTER_DATA) === 0;
  const isJobsActive = path.indexOf(JOBS) === 0;
  const isNotificationsActive = path.indexOf(NOTIFICATIONS) === 0;

  return (
    <s.Menu expanded={expanded}>
      <Link to={HOME}>
        <s.MenuItemContainer>
        <s.Item active={isDashboardActive}>
          {expanded ? <s.DashboardIcon active={isDashboardActive} />: <s.Icon active={isDashboardActive} name="home" />}
          <s.Label active={isDashboardActive}>
            <Trans>DASHBOARD</Trans>
          </s.Label>
        </s.Item>
        </s.MenuItemContainer>
      </Link>
      { hasUsersAccess && (
        <Link to={USERS}>
          <s.MenuItemContainer>
          <s.Item active={isUsersActive}>
            <s.Icon active={isUsersActive} name="users-white" />
            <s.Label active={isUsersActive}>
              <Trans>USERS</Trans>
            </s.Label>
          </s.Item>
          </s.MenuItemContainer>
        </Link>
      )}
      { hasMasterDataAccess && (
        <Link to={MASTER_DATA}>
          <s.MenuItemContainer>
          <s.Item active={isMasterDataActive}>
            <s.Icon active={isMasterDataActive} name="masterdata-white" />
            <s.Label active={isMasterDataActive}>
              <Trans>MASTER_DATA</Trans>
            </s.Label>
          </s.Item>
          </s.MenuItemContainer>
        </Link>
      )}
      <Link to={JOBS}>
        <s.MenuItemContainer>
        <s.Item active={isJobsActive}>
          <s.Icon active={isJobsActive} name="jobs-white" />
          <s.Label active={isJobsActive}>
            <Trans>JOBS</Trans>
          </s.Label>
        </s.Item>
        </s.MenuItemContainer>
      </Link>
      { isAdmin && (
        <Link to={NOTIFICATIONS}>
          <s.MenuItemContainer>
          <s.Item active={isNotificationsActive}>
            <s.Icon active={isNotificationsActive} name="notification-tool" />
            <s.Label active={isNotificationsActive}>
              <Trans>NOTIFICATIONS</Trans>
            </s.Label>
          </s.Item>
          </s.MenuItemContainer>
        </Link>
      )}
    </s.Menu>
  );
};

Menu.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  expanded: PropTypes.bool,
};

export default React.memo(withRouter(Menu));
